import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoGratuitos(state= initialState.cursoGratuitos, action){
	switch(action.type){
		case types.LOAD_CURSOS_GRATUITOS_SUCCESS:
            
			return action.datos;		
	
		default:
			return state;
	}
}